import { Select } from "@mantine/core";
import useSWR from "swr";
import { TenantApi } from "../../apis";

interface Props {
  value: string;
  onChange: (tenantId: string) => void;
  placeholder?: string;
  width?: number;
}

// Searchable tenant picker (shows tenant NAME, returns tenant id). Replaces
// raw "Tenant ID" free-text inputs — admins pick a tenant by name.
export function TenantSelect({ value, onChange, placeholder = "Тенант сонгох", width = 320 }: Props) {
  const { data } = useSWR("swr.tenants.list", () => TenantApi.list());
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const options = ((data as any[]) ?? []).map((t: any) => ({ value: t.id, label: t.name ?? t.id }));

  return (
    <Select
      placeholder={placeholder}
      data={options}
      value={value || null}
      onChange={(v) => onChange(v ?? "")}
      searchable
      clearable
      nothingFoundMessage="Тенант олдсонгүй"
      w={width}
    />
  );
}
